export default function HowToUseIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' fill='none'>
      <path
        d='m5.929 5.51 5.081 3.24-5.081 3.24V5.51ZM4 2v13.5l10.607-6.75L4 2Z'
        fill='#fff'
      />
    </svg>
  );
}
